import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteItem: [],
  loading: false,
  error: null,
};

const deleteItemSlice = createSlice({
  name: "deleteItem",
  initialState,
  reducers: {
    fetchDeleteItemSuccess: (state, action) => {
      state.loading = false;
      state.deleteItem = action.payload;
    },

    fetchDeleteItemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDeleteItemSuccess,
  fetchDeleteItemFailure,
} = deleteItemSlice.actions;

export default deleteItemSlice.reducer;